import { render, staticRenderFns } from "./EventsCenter.vue?vue&type=template&id=5ca4353b&scoped=true&"
import script from "./EventsCenter.vue?vue&type=script&lang=js&"
export * from "./EventsCenter.vue?vue&type=script&lang=js&"
import style0 from "./EventsCenter.vue?vue&type=style&index=0&id=5ca4353b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4353b",
  null
  
)

export default component.exports